export const types = {
  SET_CURRENT_SUBMISSION_ID: 'timesheetViewer/SET_CURRENT_SUBMISSION_ID',
  SET_WEEK_OF_DATE: 'timesheetViewer/SET_WEEK_OF_DATE',
  SET_USER_ID: 'timesheetViewer/SET_SUBMISSION_ITEM_ID',
};

export const setCurrentSubmissionId = (currentSubmissionId) => {
  return {
    type: types.SET_CURRENT_SUBMISSION_ID,
    currentSubmissionId,
  };
};

export const setWeekOfDate = (weekOfDate) => {
  return {
    type: types.SET_WEEK_OF_DATE,
    weekOfDate,
  };
};

export const setUserId = (userId) => {
  return {
    type: types.SET_USER_ID,
    userId,
  };
};
